var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"c-page-nav__link",class:{'is-child': _vm.isChild, 'has-children': _vm.hasChildren},attrs:{"to":("/content" + (_vm.link.data.page_url))}},[_c('span',[_vm._v(_vm._s(_vm.link.data.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }